import { DeviceType } from "../../configs/constants";

const KEY_PREFIX = "device_auth_";
const DEVICE_TYPES = [DeviceType.Pos, DeviceType.Kds, DeviceType.Cds];

const keyOf = (deviceType) => `${KEY_PREFIX}${deviceType}`;

const safeJsonParse = (raw) => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const normalizeAuth = (data) => {
  if (!data) return null;

  const device_type = data.device_type;
  if (!device_type) return null;

  return {
    device_uid: data.device_uid || data.uid || null,
    device_type,
    branch_id: data.branch_id || null,
    token: data.token || null,
    token_expires_at: data.token_expires_at || null,
  };
};

export const saveDeviceAuth = (data) => {
  const payload = normalizeAuth(data);
  if (!payload?.device_type || !payload?.token) return;

  localStorage.setItem(keyOf(payload.device_type), JSON.stringify(payload));
};

export const getDeviceAuth = (deviceType) => {
  if (!deviceType) return null;
  const raw = localStorage.getItem(keyOf(deviceType));
  if (!raw) return null;
  return safeJsonParse(raw);
};

export const getDeviceToken = (deviceType) =>
  getDeviceAuth(deviceType)?.token || null;

export const getDeviceUid = (deviceType) =>
  getDeviceAuth(deviceType)?.device_uid || null;

export const getDeviceExpiry = (deviceType) =>
  getDeviceAuth(deviceType)?.token_expires_at || null;

export const clearDeviceAuth = (deviceType) => {
  if (!deviceType) return;
  localStorage.removeItem(keyOf(deviceType));
};

export const clearAllDeviceAuth = () => {
  DEVICE_TYPES.forEach((t) => localStorage.removeItem(keyOf(t)));
};
